import React from 'react';
import cx from 'classnames';
import Typing from 'react-typing-animation';
import { cep } from '../../../../utils/mask';
import styles from '../style.module.css';
import { Address } from './types';

export const AddressDesktop = ({ address, hasSeeAddress, addressDataValue }: Address) => {
  const { city, cepAddress, district, street, additionalAddressData } = address;

  const addressText = `${street}${
    additionalAddressData ? ` - ${additionalAddressData}` : ''
  } - ${district},`;
  const restAddressText = `${city}, ${cep(cepAddress)}`;
  const text = addressText.slice(8, addressText.length);
  const truncateAddressText = addressText.slice(0, 8);
  const commonStyle = cx('gtmSeeAdress f14 abbey fw3 ma0', { truncate: !hasSeeAddress });
  const textStyle = cx('di ', styles.breakText);
  return hasSeeAddress ? (
    <>
      <Typing hideCursor className={textStyle} speed={10}>
        <p data-value={addressDataValue} className={commonStyle}>
          {truncateAddressText} {text}
        </p>
        <Typing.Delay ms={30} />
        <p data-value={addressDataValue} className={commonStyle}>
          {restAddressText}
        </p>
      </Typing>
    </>
  ) : (
    <p data-value={addressDataValue} className={commonStyle}>
      {addressText}
    </p>
  );
};
